import { render, staticRenderFns } from "./CurrentCard.vue?vue&type=template&id=2103256d&scoped=true&"
import script from "./CurrentCard.vue?vue&type=script&lang=ts&"
export * from "./CurrentCard.vue?vue&type=script&lang=ts&"
import style0 from "./CurrentCard.vue?vue&type=style&index=0&id=2103256d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2103256d",
  null
  
)

export default component.exports